var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-title"},[_c('span',[_vm._v("How to play")])]),_c('div',{staticClass:"md-layout",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100"})])])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f84a4bf","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Page/HowToPlay.vue
// module id = null
// module chunks = 